import { downloadCSV } from 'react-admin';
import { unparse as convertToCSV } from 'papaparse';
import moment from 'moment';

import resources from '../../constants/resources';
import formats from '../../constants/formats';

const exporter = (records, fetchRelatedRecords) => {
  fetchRelatedRecords(records, 'supplierId', resources.SUPPLIER).then(suppliers => {
    const data = records.map(({ id, supplierId, receivedDate }) => ({
      ID: id,
      'Intake Docket': id,
      Supplier: (suppliers[supplierId] || {}).companyName,
      'Received Date': moment(receivedDate).format(formats.DATE_TIME_EXPORT),
    }));
    const csv = convertToCSV({
      data,
    });
    downloadCSV(csv, `intake_dockets_${moment().format(formats.MOMENT)}`);
  });
};

export default exporter;
